import React, { useState } from 'react'
import YouTube from 'react-youtube'
import useMediaQuery from '../../../shared/utils/useMediaQuery'

import './modal-video.scss'

const ModalVideo = props => {
  const { setShowModalVideo } = props

  const [videoId] = useState('T5gi3VBvsXM')
  const isMobile = useMediaQuery()
  const [player, setPlayer] = useState(null)

  const onReady = event => {
    setPlayer(event.target)
  }

  const onPlayVideo = () => {
    player.playVideo()
  }

  const opts = {
    height: '400',
    width: '700',
    playerVars: {
      autoplay: 1,
    },
  }

  const optsMobile = {
    height: '200',
    width: '320',
    playerVars: {
      autoplay: 1,
    },
  }

  return (
    <div className="f-Modal-video">
      <div className="f-Modal-video__content">
        <span
          className="f-Modal-video__content-close"
          onClick={() => {
            setShowModalVideo(false)
            try {
              window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing',
                action: 'pause video',
                label: 'dale play y conocelas',
                value: '',
              })
            } catch (error) {
              console.log(error)
            }
          }}
        />
        <YouTube
          videoId={videoId ? videoId : ''}
          onReady={onReady}
          opts={isMobile ? optsMobile : opts}
          onPlay={onPlayVideo}
          onPause={() => {
            try {
              window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing',
                action: 'pause video',
                label: 'dale play y conocelas',
                value: '',
              })
            } catch (error) {
              console.log(error)
            }
          }}
        />
      </div>
    </div>
  )
}

export default ModalVideo
